__turbopack_context__.v({
  "location": "location-module-scss-module__p0yAlW__location",
  "page": "location-module-scss-module__p0yAlW__page",
});
